import React from 'react'
import { createRoot } from 'react-dom/client'
import { AdminCoursesTable } from './components/AdminCoursesTable'

const flag = value => /^(true|1)$/i.test(String(value || ''))

const json = value => {
  if (!value) return null
  try {
    return JSON.parse(value)
  } catch (e) {
    return null
  }
}

// Mount point: <div id="…" data-rows-url data-ai-url data-user data-can-create data-can-reset
// data-new-course-dialog data-reset-dialog>; props come from data attributes so nothing is interpolated into JS
export const startAdminCoursesTable = elementId => {
  const element = document.getElementById(elementId)
  const data = element.dataset
  const root = createRoot(element)
  root.render(
    <AdminCoursesTable
      rowsUrl={data.rowsUrl}
      aiUrl={data.aiUrl}
      user={data.user || ''}
      canCreate={flag(data.canCreate)}
      canReset={flag(data.canReset)}
      newCourseDialog={json(data.newCourseDialog)}
      resetDialog={json(data.resetDialog)}
    />
  )
}
